import React, { Component, Fragment } from 'react';
import { getData, dataReceived, originalDocuments, dataError } from 'datahub/actions';
import DataService from 'api/dataService';
import { filterData } from 'filters/selectors';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { images, strings } from 'config';
import {
  Page,
  DataList,
  Banner,
  SimpleDropdown,
  Pagination,
  AdvancedFilters,
  NetworkError,
} from 'components/layouts';
import { Heading, Container, Text } from 'components/styled/ui';
import { media } from 'components/styled/utils';
import { numberTranslate } from 'utils';
import {getMunicipalityFromUrl} from "../../config/subdomains";

class Home extends Component {
  state = {
    docTypesCount: {
      gov: [],
      laws: [],
      research: [],
      surveys: [],
    },
    showHighlights: false,
  };

  componentDidMount() {
    const municipalitylist = getMunicipalityFromUrl();
    const { filters } = this.props;
    const munNameSearch = decodeURIComponent(new URLSearchParams(window.location.search).get('mun'));

    if(municipalitylist.length === 1){
      const filteredResult = {
        ...filters,
        ...{
          municipality: { id: municipalitylist[0].mpc_id, name: municipalitylist[0].title, nameEn: municipalitylist[0].titleEn },
        }
      };
    } else if (munNameSearch === 'null') {  //This null will be a String
      this.props.getDataList(filters);
    }
  }

  toggleHighlights = () => {
    this.setState({
      showHighlights: !this.state.showHighlights,
    });
  };

  getCategoryCount = (type) => {
    const { dataList } = this.props;
    if (dataList.metadata.stats.length) {
      var result = dataList.metadata.stats.find((stat) => stat.name === type);

      if (result) {
        return result.count;
      }
      return 0;
    }
    return 0;
  };

  render() {
    const { showHighlights } = this.state;
    const { dataList, error } = this.props;
    const { data, meta } = dataList;

    const total_records = meta.total;

    const municipalitylist = getMunicipalityFromUrl();

    return (
      <Page>
        <Content lang={strings.getLanguage()}>
          <Banner>
            <div className="banner-content">
              <div className="banner-content__total">
                <div className="banner-top-bar">
                  <div>
                    <Heading.h1 light>
                      {numberTranslate(total_records) || numberTranslate(0)}
                    </Heading.h1>
                    <Text.span light>{strings.banner.documentsIn}</Text.span>
                  </div>
                  <span style={{ pointerEvents: municipalitylist.length === 1 ? 'none' : 'auto' }}>
                    <SimpleDropdown
                        onChange={this.onMunicipalityChange}
                        items={municipalitylist}
                    />
                  </span>
                </div>

                <ShowMoreWrap onClick={this.toggleHighlights}>
                  <span>
                    {showHighlights ? strings.banner.hideDetail : strings.banner.viewDetail}
                  </span>
                  <img src={images.icons.forward} alt="Show more" />
                </ShowMoreWrap>
              </div>

              <ul
                className={
                  showHighlights
                    ? 'banner-content__highlights'
                    : 'banner-content__highlights hidden'
                }
              >
                <li>
                  <Heading.h2 light>
                    {numberTranslate(
                      this.getCategoryCount('Laws / Bylaws / Rules / Regulations / Directives')
                    )}
                  </Heading.h2>
                  <Text.span light className="highlight-label">
                    {strings.banner.laws}
                  </Text.span>
                </li>
                <li>
                  <Heading.h2 light>
                    {numberTranslate(this.getCategoryCount('Research Reports'))}
                  </Heading.h2>
                  <Text.span light className="highlight-label">
                    {strings.banner.research}
                  </Text.span>
                </li>
                <li>
                  <Heading.h2 light>{numberTranslate(this.getCategoryCount('Surveys'))}</Heading.h2>
                  <Text.span light className="highlight-label">
                    {strings.banner.surveys}
                  </Text.span>
                </li>
                <li>
                  <Heading.h2 light>
                    {numberTranslate(this.getCategoryCount('Government Annual Progress Report'))}
                  </Heading.h2>
                  <Text.span light className="highlight-label">
                    {strings.banner.gov}
                  </Text.span>
                </li>
              </ul>
            </div>
          </Banner>

          <Container>
            <div className="row data-categories">
              <div className="col">
                <AdvancedFilters />
              </div>
              <div className="col">
                <Card>
                  <Fragment>
                    {error ? <NetworkError /> : <DataList data={data} />}
                    <div className="data-list-footer">
                      <Pagination />
                    </div>
                  </Fragment>
                </Card>
              </div>
            </div>
          </Container>
        </Content>
      </Page>
    );
  }
}

const mapStateToProps = (state) => {
  const totalRecords = state.datahub.dataList.total_records;
  const pageCount = Math.ceil(totalRecords / 10);
  return {
    dataList: state.datahub.dataList,
    searchFilters: state.datahub.searchFilters,
    dataPageCount: pageCount,
    fetching: state.datahub.fetching,
    filters: state.filters,
    error: state.datahub.error,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getDataList: (filters) => {
    dispatch(getData(filters));
    const queryParams = filterData(filters);
    DataService.getDataList(queryParams)
      .then((response) => {
        dispatch(dataReceived(response));
        dispatch(originalDocuments(response));
      })
      .catch((err) => {
        dispatch(dataError(err));
      });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);

const Content = styled.div`
  .banner-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @media screen and (min-width: 480px) {
    }

    @media screen and (min-width: 768px) {
      flex-direction: row;
      justify-content: flex-start;
    }

    &__total {
      display: flex;
      flex-direction: column;
      margin: 0 0 24px 0;
      width: 100%;

      @media screen and (min-width: 460px) {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }

      @media screen and (min-width: 768px) {
        margin: 0 80px 0 0;
        flex-direction: column;
        width: initial;
      }

      .banner-top-bar {
        margin: 0 0 12px 0;
        display: flex;
        align-items: center;

        @media screen and (min-width: 460px) {
          margin: 0;
        }

        @media screen and (min-width: 768px) {
          flex-direction: column;
        }

        > div {
          margin-right: 12px;
          text-align: center;
          > h1 {
            font-size: 28px;

            @media screen and (min-width: 768px) {
              font-size: 82px;
            }
          }

          > span {
            font-size: 16px;
            font-weight: 600;
            display: block;
            margin-bottom: 8px;
            @media screen and (min-width: 768px) {
              font-size: ${(props) => (props.lang === 'en' ? '16px' : '20px')};
            }
          }
        }
      }
    }

    &__highlights {
      display: flex;
      flex: 1;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 18px;

      @media screen and (max-width: 768px) {
        &.hidden {
          display: none;
        }
      }

      > li {
        width: calc(50% - 10px);
        text-align: center;
        margin-bottom: 12px;

        span {
          font-size: ${(props) => (props.lang === 'en' ? '14px' : '16px')};
        }

        @media screen and (min-width: 480px) {
          width: calc(50% - 10px);
        }

        @media screen and (min-width: 768px) {
          width: 25%;
          text-align: center;
        }

        h2 {
          font-size: 20px;
          margin-bottom: 8px;

          @media screen and (min-width: 768px) {
            font-size: 53px;
          }
        }
      }
    }
  }

  .data-categories {
    display: flex;
    flex-direction: column;
    margin-top: 30px;

    @media screen and (min-width: 768px) {
      flex-direction: row;
    }

    .col {
      &:first-child {
        margin: 0 0 18px 0;

        @media screen and (min-width: 768px) {
          width: 260px;
          margin: 0 30px 0 0;
        }
      }

      &:last-child {
        flex: 1;
      }
    }
  }

  .data-list-footer {
    margin-top: 30px;

    @media screen and (min-width: 768px) {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .entries-number {
      span {
        margin-right: 4px;
      }
    }
  }
`;

const Card = styled.div`
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.19);
  border-radius: 4px;
  padding-bottom: 48px;

  ${media.sm`
      /* padding: 28px 42px; */
  `};
`;

const ShowMoreWrap = styled.div`
  cursor: pointer;

  ${media.sm`
  display: none;
`};

  &:hover {
    img {
      transform: scale(0.8) rotate(90deg) translateX(2px);
    }
  }
  span,
  img {
    display: inline-block;
    vertical-align: middle;
  }

  span {
    color: #fff;
    font-size: 14px;
  }
  img {
    filter: brightness(0) invert(1);
    transform: scale(0.8) rotate(90deg) translateY(0);
    transition: all 0.2s ease-in;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/home/home.js